<template>
    <div class="transition-all hover:shadow group cursor-pointer rounded border border-grey-50" :class="contentBg">
        <div class="transition-all flex justify-between items-center py-2 px-4 text-white rounded-t group-hover:bg-glm-red" :class="titleBg">
            <h4 class="font-bold">
                <slot name="title"></slot>
            </h4>

            <span class="block mr-2">
                <font-awesome-icon
                    :class="[iconColor]"
                    class="transition-all group-hover:text-grey-300"
                    :icon="icon"
                ></font-awesome-icon>
            </span>
        </div>

        <div class="transition-all py-2 px-4 text-grey-500 group-hover:text-grey-800" :class="contentBg">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        icon: {
            default: () => ['fad', 'question'],
        },

        iconColor: {
            default: 'text-grey-600',
        },

        titleBg: {
            default: 'bg-grey-700',
        },

        contentBg: {
            default: 'bg-white',
        },
    },
}
</script>
